import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["element"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { memo } from 'react';
import { defaultProps, propTypes, FONT_SIZE, LETTER_SPACING, LINE_HEIGHT } from "./constants";
import { Typography } from "./text.styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var Text = function Text(_ref) {
  var _ref$element = _ref.element,
    element = _ref$element === void 0 ? defaultProps.element : _ref$element,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
    as: element
  }, props), {}, {
    fontSizes: FONT_SIZE,
    letterSpacings: LETTER_SPACING,
    lineHeights: LINE_HEIGHT
  }));
};
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
export default /*#__PURE__*/memo(Text);